import React, { useState, useEffect, useCallback } from 'react';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { connect } from 'react-redux';
import { Select, Button, Radio, Checkbox, Modal, DatePicker, Tooltip, message } from 'antd';
import { SFCFullModel } from '@features/common/components';
import { IRootState } from 'src/types';
import moment from 'moment';
import actions from '../../redux/actions';
import './SFCRelease.less';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

export interface ISFCReleaseProps {
  onClose: () => void;
  visiable: boolean;
  handlePublish: () => void;
  groupId?: string;
  groupChange: (val: string) => void;
  visible?: string;
  visiableChange: (val: string) => void;
  preTxt?: string;
  pushToKim?: (status: boolean) => void;
  /** 预告发布 */
  preRelease?: boolean;
  /** 分类id */
  classifyIds?: string[];
  /** 预告发布 */
  prePublish?: (prePublishDate: string) => void;
  /** 分类更新 */
  classifyChange?: (classifyIds: string[]) => void;
  /** 发布页 */
  where: string;
  /** 悬赏天数 */
  updateDays?: (val: number) => void;
  /** 悬赏金币 */
  updateKcoin?: (val: number) => void;
  /** 问题发布页 赞赏金币 */
  kCoin?: number;
  days?: number;
}
type Props = StateProps & DispatchProps & ISFCReleaseProps;

export function SFCRelease(props: Readonly<Props>) {
  const {
    groupListModel,
    onClose,
    visiable,
    handlePublish,
    groupId,
    groupChange,
    visible,
    visiableChange,
    preTxt = '文章',
    pushToKim,
    where,
    preRelease = false,
    actions: { getMyGroupsAsync, getClassifyAll, coinIncentive },
    classifyIds,
    classifyChange,
    /** 全部分类列表 */
    classifyAll,
    prePublish,
    userKcoinInfo,
    updateDays,
    updateKcoin,
    kCoin = 0
  } = props;
  const [groupLoading, setGroupLoading] = useState(false);
  const [dataPicker, setDatePicker] = useState(false);
  const [checked, setChecked] = useState(true);
  const [time, setTime] = useState('');
  // run on each update
  useEffect(() => {
    setGroupLoading(true);
    getMyGroupsAsync({
      params: { pageNum: 1, pageSize: 9999 },
      callback: () => {
        setGroupLoading(false);
      }
    });
  }, [getMyGroupsAsync]);

  useEffect(() => {
    if (visible !== 'ALL') {
      setChecked(false);
      pushToKim && pushToKim(false);
    }
  }, [checked, pushToKim, visible]);
  const handleGroupChange = (val: string) => {
    groupChange(val);

    if (!val) {
      visiableChange('ALL');
    }
  };

  // useEffect(() => {
  //   setGroupLoading(true);
  //   where === 'article' &&
  //     getClassifyAll({
  //       callBack: () => {
  //         setGroupLoading(false);
  //       }
  //     });
  // }, [getClassifyAll, where]);

  const handleClassifyChange = (valIds: string[]) => {
    valIds.length < 4 && classifyChange && classifyChange(valIds);
  };
  const radioStyle = {
    display: 'block',
    marginTop: '6px'
  };

  /**
   * @description 金币选择
   */
  const selectKcoin = (val: number) => {
    if (val > (userKcoinInfo.kcoin || 0)) {
      message.warning(`余额不足,您最多可选 ${userKcoinInfo.kcoin} 金币`);
      updateKcoin && updateKcoin(userKcoinInfo.kcoin || 0);
    } else {
      val === 0 && updateDays && updateDays(0);
      updateKcoin && updateKcoin(val);
    }
  };

  /**
   * @description 有效期限选择
   */
  const selectDays = (val: number) => {
    updateDays && updateDays(val);
  };

  /**
   * @description 展示日期选择框
   */
  const showAlert = () => {
    setDatePicker(true);
  };
  /**
   * @description 隐藏日期选择框
   */
  const hideAlert = () => {
    setDatePicker(false);
  };
  /**
   * @description 预发布
   */
  const preToPublish = () => {
    prePublish && prePublish(time);
  };
  /**
   * @description 限制选择的时间范围
   */
  const disabledDate = (current: moment.Moment) => {
    return current && (current < moment().endOf('day') || current > moment().add(14, 'd'));
  };
  /**
   * @description 预告发布日期选择
   */
  const onChange = (date: moment.Moment, dateString: string) => {
    setTime(dateString);
  };
  return (
    <>
      {visiable && (
        <SFCFullModel onClose={onClose} title={`${preTxt}发布`} className="k-common-release">
          <div className="publish__con">
            {/* {where === 'article' && (
              <div className="publish__item">
                <p className="publish__item__label">文章分类</p>
                <Select
                  showSearch
                  placeholder="选择文章类型(最多选择三个)"
                  filterOption={(input: string, option: any) =>
                    option.props.children &&
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  dropdownClassName="kstack-groupsel"
                  allowClear
                  value={classifyIds || undefined}
                  onChange={handleClassifyChange}
                  className="publish__group__select"
                  loading={groupLoading}
                  notFoundContent="暂时没有分类"
                  mode="multiple"
                >
                  {classifyAll.map(item => {
                    return (
                      <Select.Option value={item.classifyId + ''} key={item.classifyId}>
                        {item.classifyName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
            )} */}
            <div className="publish__item">
              <p className="publish__item__label">选择将{preTxt}发布到圈子</p>
              <Select
                showSearch
                placeholder="搜索圈子"
                filterOption={(input: string, option: any) =>
                  option.props.children &&
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                dropdownClassName="kstack-groupsel"
                allowClear
                // value={groupId || undefined}
                onChange={handleGroupChange}
                className="publish__group__select"
                loading={groupLoading}
                notFoundContent="你还没有加入任何圈子"
              >
                {groupListModel.map(item => {
                  return (
                    <Select.Option value={item.id + ''} key={item.id + ''}>
                      {item.groupName}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
            {/* {where === 'ask' && (
              <div className="publish__item">
                <p className="publish__item__label">是否添加悬赏</p>
                <div className="kcoin-box">
                  <Select
                    showSearch
                    placeholder="悬赏金额"
                    dropdownClassName="kstack-groupsel"
                    allowClear
                    defaultValue={kCoin}
                    value={kCoin}
                    onChange={selectKcoin}
                    className="publish__group__select kcoin__select mgr"
                    loading={groupLoading}
                  >
                    <Select.Option value={0}>无</Select.Option>
                    <Select.Option value={1}>1金币</Select.Option>
                    <Select.Option value={2}>2金币</Select.Option>
                    <Select.Option value={3}>3金币</Select.Option>
                    <Select.Option value={4}>4金币</Select.Option>
                    <Select.Option value={5}>5金币</Select.Option>
                  </Select>
                  <Select
                    showSearch
                    placeholder="悬赏有效期"
                    dropdownClassName="kstack-groupsel"
                    allowClear
                    onChange={selectDays}
                    className="publish__group__select kcoin__select"
                    loading={groupLoading}
                  >
                    <Select.Option value={1}>1天</Select.Option>
                    <Select.Option value={2}>2天</Select.Option>
                    <Select.Option value={3}>3天</Select.Option>
                    <Select.Option value={4}>4天</Select.Option>
                    <Select.Option value={5}>5天</Select.Option>
                    <Select.Option value={6}>6天</Select.Option>
                    <Select.Option value={7}>7天</Select.Option>
                  </Select>
                </div>
              </div>
            )} */}

            <div className="publish__item pdt">
              <p className="publish__item__label">{preTxt}可见范围</p>
              <Radio.Group
                className="publish__area__select"
                onChange={e => {
                  visiableChange(e.target.value);
                }}
                value={visible}
              >
                <Radio value="ALL" style={radioStyle}>
                  首页列表和圈子都可见
                  {/* <Checkbox
                    disabled={visible !== 'ALL'}
                    style={{ marginLeft: '70px', color: '#1E80F0' }}
                    onChange={e => {
                      pushToKim && pushToKim(e.target.checked);
                      setChecked(!checked);
                    }}
                    checked={checked}
                  >
                    是否推送到攻城狮大群
                  </Checkbox> */}
                </Radio>
                <Radio value="TEAM_PAGE" style={radioStyle} disabled={!groupId}>
                  仅在圈子内可见（包括游客）
                </Radio>
                {where !== 'article' ? (
                  <Radio value="TEAM_MEMBER" style={radioStyle} disabled={!groupId}>
                    仅在圈子内，且仅圈成员可见
                  </Radio>
                ) : (
                  <Radio value="ONLY_ONESELF" style={radioStyle}>
                    仅在自己个人主页可见
                  </Radio>
                )}
              </Radio.Group>
            </div>

            <Button className="btnrelease" onClick={handlePublish} type="primary">
              发布
            </Button>
            {/* {preRelease && (
              <Tooltip placement="bottom" title={'可以选择指定的发布日期哦～'}>
                <Button className="preReleaseBtn" onClick={showAlert} type="default">
                  预告
                </Button>
              </Tooltip>
            )} */}
            <Modal
              title="预告发布"
              centered
              visible={dataPicker}
              onOk={preToPublish}
              onCancel={hideAlert}
              okText={'发布'}
            >
              预告发布日期：{' '}
              <DatePicker
                onChange={onChange}
                disabledDate={disabledDate}
                // showTime={{ format: 'HH:mm' }}
                format={'YYYY-MM-DD'}
              />
            </Modal>
          </div>
        </SFCFullModel>
      )}
    </>
  );
}

/* istanbul ignore next */
function mapStateToProps(state: IRootState /*, ownProps: ISFCReleaseProps*/) {
  return {
    groupListModel: state.common.groupListModel,
    classifyAll: state.common.articleModel.classifyAll,
    userKcoinInfo: state.common.askModel.userKcoinInfo
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch: Dispatch /*, ownProps: ISFCReleaseProps*/) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect<StateProps, DispatchProps, ISFCReleaseProps>(
  mapStateToProps,
  mapDispatchToProps
)(SFCRelease);
